import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { ModalController, LoadingController } from '@ionic/angular';

import { DataService } from '../../services/data.service';
var phone_pattern;

// import { DbService } from 'src/app/service/db.service';

@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.page.html',
  styleUrls: ['./new-customer.page.scss'],
})
export class NewCustomerPage implements OnInit {

  @Input() customer_id: any;
  @Input() customer_data: any;
  @Input() address_type: any;
  @Input() address_info: any;
  newCustomer:any=FormGroup;
  submitted = false
  show: boolean = false;
  add_show=false;
  role_list:any=[];

  constructor(public loadingController: LoadingController,public db:DataService,public modalCtrl: ModalController,private frmBuilder:FormBuilder) { }

  ngOnInit() {
    // this.role_list = [{name:'Hotel Customer'},{name:'swiggy Customer'}]
    if(this.db.currency == 'USD')
      phone_pattern = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/
    else
      phone_pattern = /^((\\+91-?) |0)?[0-9]{10}$/
    if (this.address_type == "edit") {
      this.address_info.first_name = "";
      this.address_info.last_name ="";
      this.address_info.email = "";
      this.address_info.phone = "";
    }
    this.newCustomer= this.frmBuilder.group({
      first_name:new FormControl('',[Validators.required]),
      last_name: new FormControl(''), 
      email: new FormControl(''),
      // custom_role: new FormControl(''),
      phone: new FormControl('',[Validators.required,Validators.pattern(phone_pattern)]),    
    })

    if (this.customer_data) {
      this.newCustomer = this.frmBuilder.group({
        first_name: new FormControl(
          this.customer_data.first_name || '',[Validators.required],
        ),
        last_name: new FormControl(
          this.customer_data.last_name || "",
        ),
        email: new FormControl(
          this.customer_data.email,
        ),
        phone: new FormControl(this.customer_data.phone || '', [Validators.required, Validators.pattern(phone_pattern)])
      })
    }

    this.get_role()
  }

  get_role(){
   this.db.get_customer_roles().subscribe((res: any) => { 
       // console.log(res.message)
       if(res.message)
         this.role_list = res.message
     });
  }
    get validation(){
      // console.log(this.newCustomer.controls)
      return this.newCustomer.controls;
    }
    
    on_cancel() {
      this.modalCtrl.dismiss('success')
    }

    format_phone(ev) {
    if(this.db.currency == 'USD')
    { 
    let new_string = '';
    if(this.newCustomer.value.phone && this.newCustomer.value.phone.length > 0) {
      let phone = this.newCustomer.value.phone.replace(/-/g, '');
      for(var i = 0; i < phone.length; i++) {
        if((i < 3) || (i > 3 && i < 6) || (i > 6 && i < 10)) {
          new_string += phone[i];
        } else if((i == 3) || (i == 6) && phone[i] != '-') {
          new_string += '-' + phone[i];
        }
      }
    }

     this.newCustomer.get('phone').setValue(new_string)
   }

  }

  value_changed(evt) {
    // if (evt.detail.value) 
      // this.newCustomer.custom_role = evt.detail.value;
  }
  
  async customers() {
    // console.log(this.newCustomer)
    this.submitted = true;
    if (this.newCustomer.status == 'VALID') {
      let data = {
        email: this.newCustomer.value.email || this.newCustomer.value.phone.replace(/-/g, '') + '@go1.com',
        phone: this.newCustomer.value.phone,
        last_name: this.newCustomer.value.last_name,
        first_name: this.newCustomer.value.first_name,
        pwd:'Test@123',
        // custom_role: this.newCustomer.value.custom_role,
      }
      let d = {
      data: JSON.stringify(data)
    }
    const loading = await this.loadingController.create({
      // cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 4000
    });
    await loading.present();
      this.db.insert_customer(d,1).subscribe((res: any) => {
        loading.onDidDismiss();

        if (res.message.status == 'failed') {
          var a = JSON.parse(res._server_messages);
          var a1 = JSON.parse(a);
          this.db.alert(a1.message)
        }
        else {
          this.modalCtrl.dismiss(res.message);

          if (this.show) {
            this.db.alert('Updated Successfully')
          }
          else {
            this.customer_id
            this.add_show = false;
            setTimeout(() => {
             this.db.alert('New Customer created Successfully')
            }, 1000);
          }
        }
      });
    }
  }
  new_customers(arg) {
    this.submitted = true;
    if (this.newCustomer.status == 'VALID') {
      let data = {
        first_name: arg.first_name,
        last_name: arg.last_name,
        email: arg.email,
        phone: arg.phone,
        name: this.customer_data.name
      };
      let d = {
        data: JSON.stringify(data)
      }
      this.db.insert_customer(d, 1).subscribe((res: any) => {
        if (res.message.status == 'failed') {
          var d = JSON.parse(res._server_messages);
          var d1 = JSON.parse(d);
          this.db.alert(d1.message)
        }
        else {
          if (this.show) {
            this.db.alert('Updated Successfully')
          }
          else {
            this.customer_data
            this.add_show = false;
            this.db.alert('Updated Successfully')
          }
          this.modalCtrl.dismiss('success')
        } 
        
      });
    }
      }

      close(){
        this.modalCtrl.dismiss();
      }
  } 

  
